import {
  checkFileExtension,
  isObject,
  throwError,
  webpIsEnable$,
} from '../utils'
import getRequest from './create'
import { obj2string, time2str } from '@base/lang'
import { getToken } from './utils'
import { $t } from '@/i18n/LocalContext'
import cloneDeep from 'lodash/cloneDeep'
import couponImg3 from '../assets/img/back_icon_n_item_06.png'
import couponImg2 from '../assets/img/back_icon_n_item_05.png'
import couponImg1 from '../assets/img/back_icon_n_item_04.png'
import { getDefaultZone$ } from './userServer'

const _getConfig = (playerId?: string) => {
  const headers = {
    'ONEMT-PLAYERID': playerId,
    'ONEMT-TOKEN': getToken(),
  }

  return {
    headers,
  }
}

const throwRequestError = (err: unknown, name: string) => {
  let _err
  if (err instanceof Error) {
    _err = err
  } else {
    if (isObject(err) && typeof err.rtnmsg === 'string') {
      // toast($t(err.rtnmsg))
    }
    _err = new Error(`Axios (in request/${name}) Error: ${obj2string(err)}`)
  }
  window.onemtMonitor.errorReport(_err)
  console.error(_err)
}

const DEFAULT_BASE_DATA = {
  startTime: 0,
  endTime: 0,
  serverTime: 0,
  bindRewards: [] as RewardList,
  bindRewardViews: [] as RewardViewList,
  coupon: {
    count: 0,
    level: 1 as CouponLevel,
  },
  tasks: [] as TaskList,
  friends: [] as Friends,
}

const getRewardIds = (data: typeof DEFAULT_BASE_DATA) => {
  const taskRewardList = data.tasks.reduce<RewardList>(
    (res, item) =>
      res.concat(item.rewards.filter((data) => data.type === 'item')),
    []
  )
  return data.bindRewards.concat(taskRewardList).map((reward) => reward.id)
}

const getRewardViewList = (
  list: RewardList,
  propMap: Awaited<ReturnType<typeof getItems>>
) =>
  list
    .map((reward) => {
      const prop = propMap[reward.id]
      if (prop == null) {
        return {
          count: reward.count,
          name: String(reward.id),
          desc: '',
          icon: '',
          isWon: reward.isWon,
        }
      }
      return {
        count: reward.count,
        name: prop.name,
        desc: prop.desc,
        icon: prop.icon,
        isWon: reward.isWon,
      }
    })
    .filter((item) => !!item.icon)

const getRewardViews = async (data: typeof DEFAULT_BASE_DATA) => {
  const idList = getRewardIds(data)
  const propMap = await getItems(Array.from(new Set(idList)))

  data.bindRewardViews = getRewardViewList(data.bindRewards, propMap)

  data.tasks.forEach((obj) => {
    let level: CouponLevel | undefined
    obj.rewardViews = obj.rewards.map((reward) => {
      let prop: Prop | null = null
      const notCoupon = reward.type === 'item'
      if (notCoupon) {
        prop = propMap[reward.id]
      } else {
        level = parseInt(reward.id) as CouponLevel
        const name = {
          3: $t('极品抽奖券'),
          2: $t('稀有抽奖券'),
          1: $t('普通抽奖券'),
        }[level]
        const icon = {
          3: couponImg3,
          2: couponImg2,
          1: couponImg1,
        }[level]
        prop = {
          name,
          icon,
          desc: '',
        }
      }
      if (prop == null)
        return {
          count: reward.count,
          name: '',
          desc: '',
          icon: '',
        }
      const rewardView: RewardViewList[number] = {
        level,
        count: reward.count,
        name: prop.name,
        desc: prop.desc,
        icon: prop.icon,
      }
      return rewardView
    })
  })

  return data
}

export async function getPreBaseData() {
  const $request = getRequest()

  let rspData = cloneDeep(DEFAULT_BASE_DATA)
  try {
    const zoneId = await getDefaultZone$
    rspData = await $request.post(
      '/event/regression/show/home',
      { zoneId },
      _getConfig()
    )
    rspData = await getRewardViews(rspData)
  } catch (error) {
    throwRequestError(error, 'home')
  }
  return rspData
}

export async function getBaseData(playerId: string, zoneId: Zone['zoneId']) {
  const $request = getRequest()

  let rspData = cloneDeep(DEFAULT_BASE_DATA)
  try {
    rspData = await $request.post(
      '/event/regression/home/main',
      { zoneId },
      _getConfig(playerId)
    )
    rspData = await getRewardViews(rspData)
  } catch (error) {
    throwRequestError(error, 'home')
  }
  return rspData
}

export async function syncData(playerId: string) {
  const $request = getRequest()

  let rspData = {
    list: [] as Friends,
    tasks: [] as TaskList,
  }
  try {
    rspData = await $request.post(
      '/event/regression/home/friend',
      {},
      _getConfig(playerId)
    )
  } catch (error) {
    throwRequestError(error, 'home/friend')
  }
  return rspData
}

export async function bind(playerId: string) {
  const $request = getRequest()

  let res: PlayerType | 0 = 0
  try {
    const rspData = await $request.post<{ category: PlayerType }>(
      '/event/regression/user/bind',
      {},
      _getConfig(playerId)
    )
    res = rspData.category
  } catch (error) {
    throwRequestError(error, 'bind')
  }
  return res
}

export async function isbind(zoneId: Zone['zoneId']) {
  const $request = getRequest()

  let res = {
    category: 1 as PlayerType,
    isUserBind: false,
    isCodeBind: false,
    zoneId,
    playerId: '',
    serverId: '',
    nickName: '',
  }
  try {
    res = await $request.post(
      '/event/regression/show/isbind',
      {},
      {
        headers: {
          'ONEMT-TOKEN': getToken(),
        },
      }
    )
  } catch (error) {
    throwRequestError(error, 'isbind')
  }
  return res
}

export async function getRewards(playerId: string) {
  const $request = getRequest()

  let res: {
    level1: RewardList
    level2: RewardList
    level3: RewardList
  } = {
    level1: [],
    level2: [],
    level3: [],
  }
  let dataView: {
    level1: RewardViewList
    level2: RewardViewList
    level3: RewardViewList
  } = {
    level1: [],
    level2: [],
    level3: [],
  }
  try {
    res = await $request.post(
      '/event/regression/lottery/rewards',
      {},
      _getConfig(playerId)
    )
    let idList: string[] = []
    const arr = Object.keys(res)
    arr.forEach((key) => {
      const rewardList = res[key as keyof typeof res]
      rewardList.forEach((reward) => {
        idList.push(reward.id)
      })
    })
    const propMap = await getItems(Array.from(new Set(idList)))
    Object.keys(dataView).forEach((_key) => {
      const key = _key as keyof typeof res
      dataView[key] = getRewardViewList(res[key], propMap)
    })
  } catch (error) {
    throwRequestError(error, 'lottery/rewards')
  }
  return dataView
}

export async function getRecord(playerId: string) {
  const $request = getRequest()

  let rspData: RecordList = []
  try {
    const _res = await $request.post<OriginalRecordList>(
      '/event/regression/user/record',
      {},
      _getConfig(playerId)
    )
    let idList: string[] = []
    const res = _res.map((item) => {
      let rewards: Array<{ id: string; count: number }> = []
      try {
        rewards = JSON.parse(item.rewards)
      } catch (error) {
        throwError(error)
      }
      idList = idList.concat(rewards.map((data) => data.id))
      return {
        alias: item.alias,
        createdAt: item.createdAt,
        rewards,
      }
    }, [])
    const propMap = await getItems(Array.from(new Set(idList)))
    rspData = res.map((item) => {
      const map = {
        regressionbind: '回归绑定',
        regressionlottery: '抽奖',
        regressiontask: '邀请任务',
      }
      const alias = $t(map[item.alias])

      let createdAt = time2str(item.createdAt * 1000, 'date-time')
      if (typeof createdAt === 'string' && createdAt.length > 0) {
        createdAt = createdAt.replace(' ', '<br />')
      }

      const rewards = item.rewards
        .map((data) => {
          const name = propMap[data.id] ? propMap[data.id].name : 'unknow'
          return `<span>${name}*${data.count}</span>`
        })
        .join('')

      return {
        alias,
        createdAt,
        rewards,
      }
    })
  } catch (error) {
    throwRequestError(error, 'record')
  }
  return rspData
}

let cachePropMap: { [id: string]: Prop } = {}
export async function getItems(_items: string[]) {
  const $request = getRequest()
  const items = _items.filter((id) => !cachePropMap[id])

  if (items.length === 0) return cachePropMap

  let res: typeof cachePropMap = {}
  try {
    res = await $request.post(
      '/items/reward/query',
      {
        items,
        lang: window.lang,
      },
      _getConfig()
    )
    const webpIsEnable = await webpIsEnable$
    if (webpIsEnable) {
      Object.keys(res).forEach((id) => {
        const item = res[id]
        const [ext, getNewUrl] = checkFileExtension(item.icon)
        if (ext) {
          item.icon = getNewUrl('webp')
        }
      })
    }
  } catch (error) {
    throwRequestError(error, 'itemsQuery')
  }
  cachePropMap = Object.assign({}, cachePropMap, res)
  return cachePropMap
}

export async function taskShare(playerId: string) {
  const $request = getRequest()

  let rspData = {
    startTime: 0,
    endTime: 0,
    serverTime: 0,
  }
  try {
    rspData = await $request.post(
      '/event/regression/task/share',
      {},
      _getConfig(playerId)
    )
  } catch (error) {
    throwRequestError(error, 'share')
  }
  return rspData
}
export async function taskReceive(playerId: string, taskId: number) {
  const $request = getRequest()

  let rspData = {
    items: [] as RewardList,
    coupon: {
      count: 0,
      level: 1 as CouponLevel,
    },
  }
  try {
    rspData = await $request.post(
      '/event/regression/task/receive',
      { taskId },
      _getConfig(playerId)
    )
  } catch (error) {
    throwRequestError(error, 'receive')
  }
  return rspData
}

export async function bindCode(playerId: string, code: string) {
  const $request = getRequest()

  let rspData = {
    nickName: '',
    serverId: 0,
  }
  try {
    rspData = await $request.post(
      '/event/regression/invitation/bind',
      { code },
      _getConfig(playerId)
    )
  } catch (error) {
    throwRequestError(error, 'invitation/bind')
  }
  return rspData
}

export async function play(
  playerId: string,
  coupon: { level: CouponLevel; count: number }
) {
  const $request = getRequest()

  let rspData = {
    coupon,
    itemInfo: null as RewardList[number] | null,
    rewardViewList: [] as RewardViewList,
  }
  try {
    rspData = await $request.post(
      '/event/regression/lottery/play',
      {},
      _getConfig(playerId)
    )
    const idList = [rspData.itemInfo].reduce<string[]>((arr, reward) => {
      arr.push(reward.id)
      return arr
    }, [])
    const propMap = await getItems(Array.from(new Set(idList)))
    rspData.rewardViewList = getRewardViewList([rspData.itemInfo], propMap)
  } catch (error) {
    throwRequestError(error, 'invitation/bind')
  }
  return rspData
}
